import pipe from 'lodash/fp/pipe.js';
import withAppMaintenanceModePolling from '#components/support/polling/withAppMaintenanceModePolling/index.js';
import withAppVersionPolling from '#components/support/polling/withAppVersionPolling/index.js';
import ResetPassword from '#components/pages/ResetPassword/ResetPassword.jsx';

export default pipe(withAppMaintenanceModePolling, withAppVersionPolling)(ResetPassword);
